import {
  captureAppError,
  captureAppMessage,
} from '@leagueplatform/observability';
import { AUTH0_ERROR_TYPES, SENTRY_CONSTANTS } from 'common/constants';

export const captureAuthenticationError = (error: {
  type: string;
  description: string | null;
}) => {
  const lowerCaseErrorType = error.type.toLowerCase();

  if (lowerCaseErrorType.includes(AUTH0_ERROR_TYPES.LOGIN_REQUIRED)) {
    captureAppMessage(`Auth0 Error - ${error.type}`, {
      context: {
        contextDetails: {
          info: `User has been logged out due to inactivity, a new login is required - type: ${error.type}, description: ${error.description}`,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      severityLevel: 'warning',
    });
  } else {
    captureAppError(new Error(error.type), {
      errorName: `Auth0 Error - ${error.type}`,
      context: {
        contextDetails: {
          info: `An authentication error has occurred - type: ${error.type}, description: ${error.description}`,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
    });
  }
};
